// API URLs
// These are set based on the .env files
const rooturl = process.env.VUE_APP_API_ROOT;


// Auth URLs
const LOGIN = rooturl + "token";
const NEW_USER = rooturl + "api/User/post";
const CONFIRM_NEW_USER = rooturl + "api/User/EmailConfirmation";
const GET_USER_DATA = rooturl + "api/User/get";
const CHECK_EMAIL = rooturl + "api/User/CheckEmailAvailability";
const PASSWORD_RESET_EMAIL = rooturl + "api/User/PasswordReminder";
const PASSWORD_RESET_CODE = rooturl + "api/User/PasswordReset";
const PASSWORD_RESET_CHECK = rooturl + "api/User/PasswordResetCheck";
const SUBMIT_APPLICATION = rooturl + "api/Application/Post";
const RESEND_EMAIL = rooturl + "api/user/ResendEmailConfirmation";

// Validated field endpoints
const PRODUCTION_COMPANY = rooturl + "api/List/GetProductionCompanyList";
const ROAD_LIST = rooturl + "api/List/GetStreetRoadList";
const INTERSECTION_LIST = rooturl + "api/List/GetIntersectionList";
const FACILITY_LIST = rooturl + "api/List/GetFacilityList";
const SUBAREA_LIST = rooturl + "api/List/GetSubAreaList";
const ADDRESS_NUMBER_LIST = rooturl + "api/List/GetAddressList";
const ADDRESS_NAME_LIST = rooturl + "api/List/GetAddressNameList";

//saveFormData-retrieveSavedFormData-DeleteSavedFormDataById
const SAVE_FORMDATA = rooturl + "api/Application/SaveFormData";
const RETRIEVE_SAVEDFORMDATA = rooturl + "api/Application/RetrieveSavedFormData";
const DEACTIVE_SAVEDFORMDATA = rooturl + "api/Application/DeActiveSavedFormDataById";
//const DEACTIVE_SAVEDAPPDATA = rooturl + "api/Application/DeActiveSavedFormDataById";
const UPDATE_COPYSTATUS = rooturl + "api/Application/UpdateCopyStatus";

//const RETRIEVE_SAVEDFORMDATABYID = rooturl + "api/Application/retrieveSavedFormDataById/{id}";

export {
	LOGIN,
	NEW_USER,
	CONFIRM_NEW_USER,
	GET_USER_DATA,
	CHECK_EMAIL,
	PASSWORD_RESET_EMAIL,
	PASSWORD_RESET_CODE,
	PASSWORD_RESET_CHECK,
	PRODUCTION_COMPANY,
	ROAD_LIST,
	INTERSECTION_LIST,
	FACILITY_LIST,
	SUBAREA_LIST,
	ADDRESS_NUMBER_LIST,
	ADDRESS_NAME_LIST,
	SUBMIT_APPLICATION,
	RESEND_EMAIL,
	SAVE_FORMDATA,
	RETRIEVE_SAVEDFORMDATA,
	DEACTIVE_SAVEDFORMDATA,
	UPDATE_COPYSTATUS
}